export default __webpack_public_path__ + "static/media/in.e739b194.svg";